import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import CategoryIcon from '@mui/icons-material/Category';
import { SubCategorySpecificModal } from "./components/SubCategorySpecificModal";
import { SubcategoryModal } from "./components/SubcategoryModal";
import { useSubcategoryStore } from "../../hooks/useSubcategoryStore";
import { RoutesMap } from "../../types";
import { useImportStore } from "../../hooks/useImportStore";
import { DrawerDuplicated } from "./components/DrawerDuplicated";
import { DrawerOptimizated } from "./components/DrawerOptimizated";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
    // { type: 'text', field: 'description', label: 'Descripcion', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Subfamilias', pathname: RoutesMap.SUB_CATEGORIES }
]

export const SubCategoryView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionSubCategory, getSubCategories, getSubcategoriesByCompany, deleteSubCategory } = useSubcategoryStore();
    const { status: statusImport, downloadTemplate } = useImportStore()

    const [loading, setLoading] = useState(false);
    const [subcategories, setSubcategories] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showModalSubcategories, setShowModalSubcategories] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [showDuplicated, setShowDuplicated] = useState<boolean>(false)
    const [showOptimizated, setShowOptimizated] = useState<boolean>(false)

    useEffect(() => {
        getSubcategoriesApi()
    }, [])

    const getSubcategoriesApi = async (search = '') => {
        try {
            setLoading(true);
            const response = await getSubcategoriesByCompany(search);
            if (!response) {
                setSubcategories([]);
                setLoading(false);
                return false;
            } else {
                setSubcategories(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionSubCategory('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected: any) => {
        setActionSubCategory('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected: any) => {
        setActionSubCategory('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected: any) => {
        setActionSubCategory('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const showSubCategories = (rowSelected) => {
        setRowSelected(rowSelected);
        setShowModalSubcategories(true);
    }

    const onDeleteConfirm = async () => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteSubCategory(rowSelected.id)
            if (response) {
                getSubcategoriesApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSubcategoriesApi(term) }, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    const downloadTemplateApi = async () => {
        const url: string | false = await downloadTemplate(6) //6: categorias
        if (url === false) return

        const win: any = window.open(`${process.env.REACT_APP_ROOT_URL}` + url)
        win.focus()
    }

    const onImport = async (event) => {
        const file = event.target.files[0]
        if (file) {

        }
    }

    const showDrawerDuplicated = () => {
        setShowDuplicated(true)
    }

    const showDrawerOptimizated = () => {
        setShowOptimizated(true)
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    breadcrumbs={breadcrumbs}
                    title={'Subfamilias'}
                    columns={columns}
                    loading={loading}
                    rows={subcategories || []}
                    onRowClick={() => { }}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nueva subfamilia'}
                    // onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onHelper={showSubCategories}
                    icon_helper={<CategoryIcon fontSize="small" />}
                    tooltip_helper={'subfamilias específicas'}
                    onSearch={onSearch}
                    dense
                    onImport={onImport}
                    template={downloadTemplateApi}
                    textInfo={'Existen subfamilias con duplicadas'}
                    redirecInfo={showDrawerDuplicated}
                    textRedirect={'Ver subfamilias duplicadas'}
                    textInfo2={'Existe data a optimizar'}
                    redirecInfo2={showDrawerOptimizated}
                    textRedirect2={'Ver data a optimizar'}
                />
            </Grid>
            {
                showModal && (
                    <SubcategoryModal
                        open={showModal}
                        closeModal={() => { setShowModal(false) }}
                        subcategorySelected={rowSelected}
                        listsubcategories={getSubcategoriesApi}
                        clearState={clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false); clearState() }}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
            {
                showModalSubcategories && (
                    <SubCategorySpecificModal
                        open={showModalSubcategories}
                        closeModal={() => { setShowModalSubcategories(false) }}
                        subcategorySelected={rowSelected}
                        clearState={clearState}
                    />
                )
            }
             {
                showDuplicated && (
                    <DrawerDuplicated
                        open={showDuplicated}
                        closeModal={()=>{setShowDuplicated(false)}}
                    />
                )
            }
            {
               showOptimizated  && (
                    <DrawerOptimizated
                     open={showOptimizated}
                     closeModal={()=>{setShowOptimizated(false)}}
                     />
                )
            }
        </>
    )
}